import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const X = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.1638 4.1638C4.38221 3.94541 4.73608 3.9454 4.95448 4.1638L8.00391 7.21244L11.0276 4.1888C11.2459 3.97045 11.5998 3.97055 11.8182 4.1888C12.0366 4.4072 12.0366 4.76107 11.8182 4.97948L8.79459 8.0039L11.8362 11.0455C12.0546 11.2639 12.0546 11.6178 11.8362 11.8362C11.6178 12.0546 11.2639 12.0546 11.0455 11.8362L8.00391 8.79458L4.98183 11.8167C4.76342 12.0351 4.40877 12.0351 4.19037 11.8167C3.97221 11.5983 3.97227 11.2444 4.19037 11.026L7.21245 8.0039L4.1638 4.95448C3.9454 4.73607 3.9454 4.3822 4.1638 4.1638Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default X;
